import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Placement in Another School' },
    { value: 2, label: 'Placement in an Alternative Program' },
  ],
});
